import React, { createContext, useState, useContext, useMemo } from 'react';

type AnatomicRegionSynchronyzerContextType = {
  anatomicRegion: string;
  setAnatomicRegion: (region: string) => void;
};

const AnatomicRegionSynchronyzerContext = createContext<
  AnatomicRegionSynchronyzerContextType | undefined
>(undefined);

export const AnatomicRegionSynchronyzerProvider = ({ children }: { children: React.ReactNode }) => {
  const [anatomicRegion, setAnatomicRegion] = useState<string>('');

  const value = useMemo(() => ({ anatomicRegion, setAnatomicRegion }), [anatomicRegion]);

  return (
    <AnatomicRegionSynchronyzerContext.Provider value={value}>
      {children}
    </AnatomicRegionSynchronyzerContext.Provider>
  );
};

export const useAnatomicRegionSynchronyzer = () => {
  const context = useContext(AnatomicRegionSynchronyzerContext);
  if (context === undefined) {
    throw new Error('useAnatomicRegion must be used within an AnatomicRegionProvider');
  }
  return context;
};
